module.exports = __webpack_public_path__ + "img/fire-seven.40917572.svg";